// supabase/functions/_shared/booking/token.ts
// Manage tokens (spec booking §3.4): 32 random bytes as base64url; only the SHA-256 hex is stored. Client IPs (the
// 24-hour limit) are stored as an HMAC-SHA-256 with a function secret (preflight L7: an unsalted hash of an IPv4 address
// is reversible by enumeration). Web Crypto only: the same file runs in Deno (edge), Node (tests) and the browser.
export const MANAGE_TOKEN_RE = /^[A-Za-z0-9_-]{43}$/;

const base64url = (bytes: Uint8Array): string => {
  let s = "";
  for (const b of bytes) s += String.fromCharCode(b);
  return btoa(s).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};
const hex = (buf: ArrayBuffer): string =>
  Array.from(new Uint8Array(buf), (b) => b.toString(16).padStart(2, "0")).join(
    "",
  );

export async function sha256Hex(s: string): Promise<string> {
  return hex(
    await crypto.subtle.digest("SHA-256", new TextEncoder().encode(s)),
  );
}

export async function hmacSha256Hex(
  key: string,
  message: string,
): Promise<string> {
  const k = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(key),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );
  return hex(
    await crypto.subtle.sign("HMAC", k, new TextEncoder().encode(message)),
  );
}

export async function newManageToken(): Promise<{
  token: string;
  hash: string;
}> {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  const token = base64url(bytes);
  return { token, hash: await sha256Hex(token) };
}
